<div [formGroup]="form" class="custom-headers" data-test-id="custom-headers">
  @if (form.get(headersControlName)) {
    <div [formArrayName]="headersControlName">
      @for (control of headersValues; track control; let index = $index) {
        <div class="d-flex flex-column flex-lg-row gap-3 mb-3" [formGroupName]="index">
          <div class="col-lg">
            <ds-input
              [label]="nameLabel | translate"
              [errorState]="getNameError(index)?.length > 0"
              [errorMessage]="getNameError(index) | translate"
            >
              <input ds-input-field class="form-control" [formControlName]="$fields.name" />
            </ds-input>
          </div>
          <div class="col-lg">
            <ds-input
              [label]="valueLabel | translate"
              [errorState]="getValueError(index)?.length > 0"
              [errorMessage]="getValueError(index) | translate"
            >
              <input ds-input-field class="form-control" [formControlName]="$fields.value" />
            </ds-input>
          </div>
          <button
            ds-button
            type="button"
            [variant]="DsButtonVariants.microAction"
            [microActionIcon]="Icons.TrashCan"
            [intent]="DsButtonIntent.destructive"
            (click)="removeControl(index)"
          >
            {{ deleteButtonLabel | translate }}
          </button>
        </div>
      }
      <button
        ds-button
        class="mb-3"
        type="button"
        [variant]="DsButtonVariants.microActionHorizontalLayout"
        [hideMicroActionIcon]="true"
        (click)="addControl()"
        data-e2e-id="add-pair"
      >
        {{ addButtonLabel | translate }}
      </button>
    </div>
  }
</div>
